import { Language } from "../../assets/languages/langs";

/**
 * Indicator texts for screens without loaded translations (login). Same as
 * `mainLayout.header.connectionQuality` in Node-taxi-server languages/*.yml;
 * the test checks that every language has every key of dev.yml.
 */
export const CONNECTION_TEXTS: Record<Language, Record<string, string>> = {
	en: {
		title: "Connection to server",
		"level.good": "good",
		"level.fair": "fair",
		"level.poor": "poor",
		"level.unstable": "unstable",
		"level.unknown": "checking",
		"level.offline": "no network",
		"level.noServer": "no response",
		"hint.offline":
			"This computer is not connected to a network. Check the cable or Wi-Fi.",
		"hint.noServer":
			"The server is not responding. The cause may be the provider, the router or the server.",
		"hint.poor":
			"The server responds slowly: orders and commands arrive with a delay.",
		"hint.unstable":
			"The delay jumps a lot. Wi-Fi is the usual cause: check the signal or plug in a cable.",
		ping: "Delay",
		ms: "{{value}} ms",
		lost: "Lost checks",
		lostValue: "{{lost}} of {{total}}",
		reconnects: "Reconnects",
		checkedAt: "Last check",
		internet: "Internet",
		"internetVerdict.ok": "available",
		"internetVerdict.down": "unavailable",
		"internetVerdict.unknown": "could not check",
		ip: "External IP",
	},
	uk: {
		title: "Зв'язок із сервером",
		"level.good": "добрий",
		"level.fair": "середній",
		"level.poor": "поганий",
		"level.unstable": "нестабільний",
		"level.unknown": "перевіряється",
		"level.offline": "немає мережі",
		"level.noServer": "немає відповіді",
		"hint.offline":
			"Комп'ютер не підключено до мережі. Перевірте кабель або Wi-Fi.",
		"hint.noServer":
			"Сервер не відповідає. Причина може бути в провайдера, у роутері або на сервері.",
		"hint.poor":
			"Сервер відповідає повільно: замовлення й команди доходять із затримкою.",
		"hint.unstable":
			"Затримка сильно стрибає. Найчастіше так буває через Wi-Fi: перевірте сигнал або підключіть кабель.",
		ping: "Затримка",
		ms: "{{value}} мс",
		lost: "Втрачено перевірок",
		lostValue: "{{lost}} з {{total}}",
		reconnects: "Перепідключень",
		checkedAt: "Остання перевірка",
		internet: "Інтернет",
		"internetVerdict.ok": "є",
		"internetVerdict.down": "немає",
		"internetVerdict.unknown": "не вдалося перевірити",
		ip: "Зовнішній IP",
	},
	ru: {
		title: "Связь с сервером",
		"level.good": "хорошая",
		"level.fair": "средняя",
		"level.poor": "плохая",
		"level.unstable": "нестабильная",
		"level.unknown": "проверяется",
		"level.offline": "нет сети",
		"level.noServer": "нет ответа",
		"hint.offline":
			"Компьютер не подключён к сети. Проверьте кабель или Wi-Fi.",
		"hint.noServer":
			"Сервер не отвечает. Причина может быть у провайдера, в роутере или на сервере.",
		"hint.poor":
			"Сервер отвечает медленно: заказы и команды доходят с задержкой.",
		"hint.unstable":
			"Задержка сильно скачет. Чаще всего так бывает из-за Wi-Fi: проверьте сигнал или подключите кабель.",
		ping: "Задержка",
		ms: "{{value}} мс",
		lost: "Потеряно проверок",
		lostValue: "{{lost}} из {{total}}",
		reconnects: "Переподключений",
		checkedAt: "Последняя проверка",
		internet: "Интернет",
		"internetVerdict.ok": "есть",
		"internetVerdict.down": "нет",
		"internetVerdict.unknown": "не удалось проверить",
		ip: "Внешний IP",
	},
	tr: {
		title: "Sunucu bağlantısı",
		"level.good": "iyi",
		"level.fair": "orta",
		"level.poor": "zayıf",
		"level.unstable": "dengesiz",
		"level.unknown": "kontrol ediliyor",
		"level.offline": "ağ yok",
		"level.noServer": "yanıt yok",
		"hint.offline":
			"Bilgisayar bir ağa bağlı değil. Kabloyu veya Wi-Fi'ı kontrol edin.",
		"hint.noServer":
			"Sunucu yanıt vermiyor. Sorun sağlayıcıda, modemde veya sunucuda olabilir.",
		"hint.poor":
			"Sunucu yavaş yanıt veriyor: siparişler ve komutlar gecikmeli ulaşıyor.",
		"hint.unstable":
			"Gecikme çok dalgalanıyor. Genellikle sebep Wi-Fi'dır: sinyali kontrol edin veya kablo bağlayın.",
		ping: "Gecikme",
		ms: "{{value}} ms",
		lost: "Kaybolan kontroller",
		lostValue: "{{lost}} / {{total}}",
		reconnects: "Yeniden bağlanma",
		checkedAt: "Son kontrol",
		internet: "İnternet",
		"internetVerdict.ok": "var",
		"internetVerdict.down": "yok",
		"internetVerdict.unknown": "kontrol edilemedi",
		ip: "Dış IP",
	},
	az: {
		title: "Serverlə əlaqə",
		"level.good": "yaxşı",
		"level.fair": "orta",
		"level.poor": "zəif",
		"level.unstable": "qeyri-sabit",
		"level.unknown": "yoxlanılır",
		"level.offline": "şəbəkə yoxdur",
		"level.noServer": "cavab yoxdur",
		"hint.offline":
			"Kompüter şəbəkəyə qoşulmayıb. Kabeli və ya Wi-Fi-ı yoxlayın.",
		"hint.noServer":
			"Server cavab vermir. Səbəb provayderdə, routerdə və ya serverdə ola bilər.",
		"hint.poor":
			"Server yavaş cavab verir: sifarişlər və əmrlər gecikmə ilə çatır.",
		"hint.unstable":
			"Gecikmə çox dəyişir. Adətən səbəb Wi-Fi olur: siqnalı yoxlayın və ya kabel qoşun.",
		ping: "Gecikmə",
		ms: "{{value}} ms",
		lost: "İtirilmiş yoxlamalar",
		lostValue: "{{lost}} / {{total}}",
		reconnects: "Yenidən qoşulmalar",
		checkedAt: "Son yoxlama",
		internet: "İnternet",
		"internetVerdict.ok": "var",
		"internetVerdict.down": "yoxdur",
		"internetVerdict.unknown": "yoxlamaq mümkün olmadı",
		ip: "Xarici IP",
	},
	ro: {
		title: "Conexiune cu serverul",
		"level.good": "bună",
		"level.fair": "medie",
		"level.poor": "slabă",
		"level.unstable": "instabilă",
		"level.unknown": "se verifică",
		"level.offline": "fără rețea",
		"level.noServer": "fără răspuns",
		"hint.offline":
			"Calculatorul nu este conectat la rețea. Verificați cablul sau Wi-Fi-ul.",
		"hint.noServer":
			"Serverul nu răspunde. Cauza poate fi la furnizor, la router sau la server.",
		"hint.poor": "Serverul răspunde încet: comenzile ajung cu întârziere.",
		"hint.unstable":
			"Întârzierea variază mult. De obicei cauza este Wi-Fi-ul: verificați semnalul sau conectați un cablu.",
		ping: "Întârziere",
		ms: "{{value}} ms",
		lost: "Verificări pierdute",
		lostValue: "{{lost}} din {{total}}",
		reconnects: "Reconectări",
		checkedAt: "Ultima verificare",
		internet: "Internet",
		"internetVerdict.ok": "disponibil",
		"internetVerdict.down": "indisponibil",
		"internetVerdict.unknown": "nu s-a putut verifica",
		ip: "IP extern",
	},
	ka: {
		title: "კავშირი სერვერთან",
		"level.good": "კარგი",
		"level.fair": "საშუალო",
		"level.poor": "სუსტი",
		"level.unstable": "არასტაბილური",
		"level.unknown": "მოწმდება",
		"level.offline": "ქსელი არ არის",
		"level.noServer": "პასუხი არ არის",
		"hint.offline":
			"კომპიუტერი ქსელთან არ არის დაკავშირებული. შეამოწმეთ კაბელი ან Wi-Fi.",
		"hint.noServer":
			"სერვერი არ პასუხობს. მიზეზი შეიძლება იყოს პროვაიდერთან, როუტერში ან სერვერზე.",
		"hint.poor":
			"სერვერი ნელა პასუხობს: შეკვეთები და ბრძანებები დაგვიანებით აღწევს.",
		"hint.unstable":
			"დაყოვნება ძლიერ იცვლება. ხშირად მიზეზი Wi-Fi-ა: შეამოწმეთ სიგნალი ან შეაერთეთ კაბელი.",
		ping: "დაყოვნება",
		ms: "{{value}} მწ",
		lost: "დაკარგული შემოწმებები",
		lostValue: "{{lost}} / {{total}}",
		reconnects: "ხელახალი დაკავშირებები",
		checkedAt: "ბოლო შემოწმება",
		internet: "ინტერნეტი",
		"internetVerdict.ok": "არის",
		"internetVerdict.down": "არ არის",
		"internetVerdict.unknown": "ვერ შემოწმდა",
		ip: "გარე IP",
	},
	pl: {
		title: "Połączenie z serwerem",
		"level.good": "dobre",
		"level.fair": "średnie",
		"level.poor": "słabe",
		"level.unstable": "niestabilne",
		"level.unknown": "sprawdzanie",
		"level.offline": "brak sieci",
		"level.noServer": "brak odpowiedzi",
		"hint.offline":
			"Komputer nie jest podłączony do sieci. Sprawdź kabel lub Wi-Fi.",
		"hint.noServer":
			"Serwer nie odpowiada. Przyczyna może leżeć po stronie dostawcy, routera lub serwera.",
		"hint.poor":
			"Serwer odpowiada wolno: zamówienia i polecenia docierają z opóźnieniem.",
		"hint.unstable":
			"Opóźnienie mocno się waha. Zwykle przyczyną jest Wi-Fi: sprawdź sygnał lub podłącz kabel.",
		ping: "Opóźnienie",
		ms: "{{value}} ms",
		lost: "Utracone sprawdzenia",
		lostValue: "{{lost}} z {{total}}",
		reconnects: "Ponowne połączenia",
		checkedAt: "Ostatnie sprawdzenie",
		internet: "Internet",
		"internetVerdict.ok": "jest",
		"internetVerdict.down": "brak",
		"internetVerdict.unknown": "nie udało się sprawdzić",
		ip: "Zewnętrzny IP",
	},
};
